export enum globalActionTypes {
  GET_TOOLTIPS_REQUEST = 'GET_TOOLTIPS_REQUEST',
  GET_TOOLTIPS_SUCCESS = 'GET_TOOLTIPS_SUCCESS',
  GET_TOOLTIPS_FAILED = 'GET_TOOLTIPS_FAILED',

  DEFAULT_CONFIGURATIONS_REQUEST = 'DEFAULT_CONFIGURATIONS_REQUEST',
  DEFAULT_CONFIGURATIONS_SUCCESS = 'DEFAULT_CONFIGURATIONS_SUCCESS',
  DEFAULT_CONFIGURATIONS_FAILED = 'DEFAULT_CONFIGURATIONS_FAILED',
}